////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: /news-item/:slug -> /news/:slug — preserves the old site's slug //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { Navigate, useParams } from 'react-router';

// Kept as its own tiny route component (rather than a static `to=` string on the
// route object) because the target path depends on the matched :slug param —
// existing inbound links and search results to /news-item/<slug> must land on the
// equivalent /news/<slug> article, not just on the News listing.
export function LegacyNewsItemRedirect () {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/news/${slug ?? ''}`} replace />;
}
